// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ActionsPopoverLink = t.struct({
    label: t.String,
    route: t.String
}, 'ActionsPopoverLink');

export default ActionsPopoverLink;



// WEBPACK FOOTER //
// ./src/shared/state/actions-popover-link.js